var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.557,
    height: 34.001,
    viewBox: "0 0 32.557 34.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8554",
    "data-name": "Group 8554",
    transform: "translate(-4648 3787.301)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8553",
    "data-name": "Group 8553"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-bag-6787836",
    transform: "translate(4634.316 -3799.337)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8552",
    "data-name": "Group 8552",
    transform: "translate(14.094 12.336)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M45.923,40.382,44.567,20.464a5.019,5.019,0,0,0-4.621-4.647,5.409,5.409,0,0,0-5.068-3.481l-9.727,0a5.4,5.4,0,0,0-5.068,3.481,5.026,5.026,0,0,0-4.621,4.656L14.106,40.387a5.035,5.035,0,0,0,1.344,3.764,4.96,4.96,0,0,0,3.658,1.586H40.931a5.007,5.007,0,0,0,4.992-5.355ZM25.151,14.112h9.728a3.654,3.654,0,0,1,3.09,1.689H22.056a3.652,3.652,0,0,1,3.1-1.689ZM43.293,42.937a3.2,3.2,0,0,1-2.362,1.024H19.106a3.24,3.24,0,0,1-3.232-3.454L17.23,20.595a3.24,3.24,0,0,1,3.228-3.019H39.564a3.243,3.243,0,0,1,3.232,3.01l1.356,19.921a3.2,3.2,0,0,1-.859,2.43Z",
    transform: "translate(-14.094 -12.336)",
    fill: "#1c1919",
    stroke: "#ede5de",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M47.478,33.163a.889.889,0,0,0-1.108.589,5.893,5.893,0,0,1-11.272,0,.888.888,0,1,0-1.7.52,7.668,7.668,0,0,0,14.668-.005.881.881,0,0,0-.591-1.1Z",
    transform: "translate(-24.819 -23.907)",
    fill: "#1c1919",
    stroke: "#ede5de",
    strokeWidth: 0.6
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(4677 -3772)",
    fill: "#ede5de"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_662",
    "data-name": "Rectangle 662",
    width: 4,
    height: 5,
    rx: 2,
    transform: "translate(4648 -3772)",
    fill: "#ede5de"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_663",
    "data-name": "Rectangle 663",
    width: 3,
    height: 2,
    rx: 1,
    transform: "translate(4648 -3763)",
    fill: "#ede5de"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/cart_icon.f6d810c9c4141439e958f3467c5678d8.svg";
export { ForwardRef as ReactComponent };